import { EventAvailable } from "@mui/icons-material"
import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"

// Click-to-select-row batch picker — mirrors the bordered Stack rows pattern
// used in src/controller/student-info.jsx's "Assign batch" dialog.
export default function BatchPicker({ value, onChange }) {
	const apiUrl = process.env.REACT_APP_API

	const [batches, setBatches] = useState([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		setLoading(true)
		axios
			.get(`${apiUrl}/franchise/batch/getall?status=active&limit=100`)
			.then((res) => setBatches(res.data.status === true ? res.data.data || [] : []))
			.catch(() => setBatches([]))
			.finally(() => setLoading(false))
	}, [apiUrl])

	const formatBatchTime = (time) => {
		if (!time) return "--"
		const [hour, minute] = time.split(":")
		const hour12 = ((parseInt(hour, 10) + 11) % 12) + 1
		const suffix = parseInt(hour, 10) >= 12 ? "PM" : "AM"
		return `${hour12}:${minute} ${suffix}`
	}

	if (loading) {
		return (
			<Box textAlign="center" py={3}>
				<CircularProgress size={24} />
			</Box>
		)
	}

	if (batches.length === 0) {
		return (
			<Alert severity="info" sx={{ mt: 1 }}>
				No active batches found. Create one from the Batch module first.
			</Alert>
		)
	}

	return (
		<Stack spacing={1}>
			{batches.map((batch) => (
				<Stack
					key={batch.batch_id}
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					onClick={() => onChange(batch.batch_id)}
					sx={{
						border: "thin solid",
						borderColor: value === batch.batch_id ? "primary.main" : "#CCCCCC",
						bgcolor: value === batch.batch_id ? "primary.lighter" : "transparent",
						borderRadius: 1.5,
						padding: 1.2,
						cursor: "pointer",
					}}
				>
					<Box>
						<Typography fontSize={16} fontWeight="bold">
							{batch.batch_name}
						</Typography>
						<Typography fontSize={13} color="gray">
							{formatBatchTime(batch.batch_start)} – {formatBatchTime(batch.batch_end)}
						</Typography>
					</Box>
					{value === batch.batch_id && <EventAvailable color="primary" />}
				</Stack>
			))}
		</Stack>
	)
}
